module.exports = __webpack_public_path__ + "static/media/globo-nubes-sol.f8ffd924.png";